export default "__VITE_ASSET__VuclELWk__"